import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  SupplierFilterSupplierBank,
  SupplierUpdateSupplierBank,
  SupplierCreateSupplierBank,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function SupplierBankAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const navigate = useNavigate();

  let { id, extra } = useParams();

  const start = async () => {
    try {
      if (extra) {
        const SupplierFilterSupplierBankData = await SupplierFilterSupplierBank(
          {
            id: extra,
          }
        );
        if (
          SupplierFilterSupplierBankData.status &&
          SupplierFilterSupplierBankData.status === 200
        ) {
          setForm(SupplierFilterSupplierBankData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (form.iban === "") {
      toast.error("شبا را وارد نمایید ");
      validation = false;
    }
    if (form.accountNumber === "") {
      toast.error("حساب را وارد نمایید ");
      validation = false;
    }
    if (form.cardNumber === "") {
      toast.error("کارت را وارد نمایید ");
      validation = false;
    }
    if (form.fullName === "") {
      toast.error("نام کامل را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (extra) {
          const SupplierUpdateSupplierBankData =
            await SupplierUpdateSupplierBank(form);
          if (
            SupplierUpdateSupplierBankData.status &&
            SupplierUpdateSupplierBankData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Suppliers/Bank/" + id);
          }
        } else {
          const SupplierCreateSupplierBankData =
            await SupplierCreateSupplierBank({
              ...form,
              SupplierId: id,
            });
          if (
            SupplierCreateSupplierBankData.status &&
            SupplierCreateSupplierBankData.status === 200
          ) {
            toast.success("افزودن با موفقیت انجام شد");
            navigate("/Panel/Suppliers/Bank/" + id);
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="iban"
                id="iban"
                text="شبا"
                value={form.iban || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="accountNumber"
                id="accountNumber"
                text="حساب"
                value={form.accountNumber || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="cardNumber"
                id="cardNumber"
                text="کارت"
                value={form.cardNumber || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="fullName"
                id="fullName"
                text="نام کامل"
                value={form.fullName || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {extra ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierBankAE;
